import React from "react";
import { Grid } from "semantic-ui-react";

const ResponsiveColumnModel = ({ withBorder, show, ...props }) => {
  return <Grid.Column {...props}></Grid.Column>;
};

export default ResponsiveColumnModel;
